// extracted by mini-css-extract-plugin
module.exports = {"financeEventIcon":"style_financeEventIcon__2Px0r","typeIcon":"style_typeIcon__AjzhS","statusIcon":"style_statusIcon__3wgjc"};